import { Entity } from '../entity';
import { LanguagePage, PageTitles } from '../lib/common';

export interface RouteOptimizerAddress {
  alias: string;
  address: string;
  lat: number;
  lng: number;
}

export interface IRouteOptimizerCreateResponse {
  createdBy: string;
  modifiedBy: string;
  id: string;
  territoryId: number;
  optimizationStatus: string;
  optimizationResult: string;
}

export interface IRouteOptimizerStatusResponse {
  optimization: {
    createdAt: string;
    createdBy: string;
    href: string;
    id: string;
    inputParameter: string;
    modifiedAt: string;
    modifiedBy: string;
    outputParameter: string;
    territoryId: number;
  };
  state: number;
}

export class RouteOptimizerResponse implements IRouteOptimizerCreateResponse {
  public createdBy: string;
  public modifiedBy: string;
  public id: string;
  public territoryId: number;
  public optimizationResult: string;
  public optimizationStatus: string;

  constructor(response: IRouteOptimizerCreateResponse) {
    this.createdBy = response.createdBy;
    this.modifiedBy = response.modifiedBy;
    this.id = response.id;
    this.territoryId = response.territoryId;
    this.optimizationResult = response.optimizationResult;
    this.optimizationStatus = response.optimizationStatus;
  }
}
